import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Hero from './components/Hero'
import Footer from './components/Footer'
import ProductOverview from './pages/ProductOverview'
import DialogueFeatures from './pages/DialogueFeatures'
import MusicFeatures from './pages/MusicFeatures'
import SmartFeatures from './pages/SmartFeatures'
import BasicOperations from './pages/BasicOperations'

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Routes>
          <Route path="/" element={<><Hero /><Footer /></>} />
          <Route path="/product-overview" element={<><ProductOverview /><Footer /></>} />
          <Route path="/dialogue-features" element={<><DialogueFeatures /><Footer /></>} />
          <Route path="/music-features" element={<><MusicFeatures /><Footer /></>} />
          <Route path="/smart-features" element={<><SmartFeatures /><Footer /></>} />
          <Route path="/basic-operations" element={<><BasicOperations /><Footer /></>} />
        </Routes>
      </div>
    </Router>
  )
}

export default App
